import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="container email-login clearfix">
  <div class="content-wrapper">
    <div class="image-wrapper">
      <img src={{this.lockImageUrl}} class="password-reset-img" alt="" />
    </div>

    <form>
      {{#if this.model.error}}
        <div class="error-info">
          {{html-safe this.model.error}}
        </div>
      {{/if}}

      {{#if this.model.can_login}}
        <div class="email-login-form">
          {{#if this.secondFactorRequired}}
            {{#if this.model.security_key_required}}
              <SecurityKeyForm
                @setShowSecurityKey={{fn
                  (mut this.model.security_key_required)
                }}
                @setSecondFactorMethod={{fn (mut this.secondFactorMethod)}}
                @backupEnabled={{this.model.backup_codes_enabled}}
                @totpEnabled={{this.model.totp_enabled}}
                @otherMethodAllowed={{this.secondFactorRequired}}
                @action={{this.authenticateSecurityKey}}
              />
            {{else}}
              <SecondFactorForm
                @secondFactorMethod={{this.secondFactorMethod}}
                @secondFactorToken={{this.secondFactorToken}}
                @backupEnabled={{this.model.backup_codes_enabled}}
                @totpEnabled={{this.model.totp_enabled}}
                @isLogin={{true}}
              >
                <SecondFactorInput
                  {{on
                    "input"
                    (with-event-value (fn (mut this.secondFactorToken)))
                  }}
                  @secondFactorMethod={{this.secondFactorMethod}}
                  value={{this.secondFactorToken}}
                />
              </SecondFactorForm>
            {{/if}}
          {{else}}
            <h2>{{i18n
                "email_login.confirm_title"
                site_name=this.siteSettings.title
              }}</h2>
            <p>{{i18n
                "email_login.logging_in_as"
                email=this.model.token_email
              }}</p>
          {{/if}}

          {{#unless this.model.security_key_required}}
            <DButton
              @label="email_login.confirm_button"
              @action={{action "finishLogin"}}
              type="submit"
              class="btn-primary"
            />
          {{/unless}}
        </div>
      {{/if}}
    </form>
  </div>
</div>
*/
{
  "id": "EK/I4PS2",
  "block": "[[[10,0],[14,0,\"container email-login clearfix\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"content-wrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"image-wrapper\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"src\",[30,0,[\"lockImageUrl\"]]],[14,0,\"password-reset-img\"],[14,\"alt\",\"\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"form\"],[12],[1,\"\\n\"],[41,[30,0,[\"model\",\"error\"]],[[[1,\"        \"],[10,0],[14,0,\"error-info\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,0,[\"model\",\"error\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"model\",\"can_login\"]],[[[1,\"        \"],[10,0],[14,0,\"email-login-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"secondFactorRequired\"]],[[[41,[30,0,[\"model\",\"security_key_required\"]],[[[1,\"              \"],[8,[39,2],null,[[\"@setShowSecurityKey\",\"@setSecondFactorMethod\",\"@backupEnabled\",\"@totpEnabled\",\"@otherMethodAllowed\",\"@action\"],[[28,[37,3],[[28,[37,4],[[30,0,[\"model\",\"security_key_required\"]]],null]],null],[28,[37,3],[[28,[37,4],[[30,0,[\"secondFactorMethod\"]]],null]],null],[30,0,[\"model\",\"backup_codes_enabled\"]],[30,0,[\"model\",\"totp_enabled\"]],[30,0,[\"secondFactorRequired\"]],[30,0,[\"authenticateSecurityKey\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,5],null,[[\"@secondFactorMethod\",\"@secondFactorToken\",\"@backupEnabled\",\"@totpEnabled\",\"@isLogin\"],[[30,0,[\"secondFactorMethod\"]],[30,0,[\"secondFactorToken\"]],[30,0,[\"model\",\"backup_codes_enabled\"]],[30,0,[\"model\",\"totp_enabled\"]],true]],[[\"default\"],[[[[1,\"\\n                \"],[8,[39,6],[[16,2,[30,0,[\"secondFactorToken\"]]],[4,[38,7],[\"input\",[28,[37,8],[[28,[37,3],[[28,[37,4],[[30,0,[\"secondFactorToken\"]]],null]],null]],null]],null]],[[\"@secondFactorMethod\"],[[30,0,[\"secondFactorMethod\"]]]],null],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],[[[1,\"            \"],[10,\"h2\"],[12],[1,[28,[35,9],[\"email_login.confirm_title\"],[[\"site_name\"],[[30,0,[\"siteSettings\",\"title\"]]]]]],[13],[1,\"\\n            \"],[10,2],[12],[1,[28,[35,9],[\"email_login.logging_in_as\"],[[\"email\"],[[30,0,[\"model\",\"token_email\"]]]]]],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[51,[30,0,[\"model\",\"security_key_required\"]]],[[[1,\"            \"],[8,[39,11],[[24,0,\"btn-primary\"],[24,4,\"submit\"]],[[\"@label\",\"@action\"],[\"email_login.confirm_button\",[28,[37,12],[[30,0],\"finishLogin\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"if\",\"html-safe\",\"security-key-form\",\"fn\",\"mut\",\"second-factor-form\",\"second-factor-input\",\"on\",\"with-event-value\",\"i18n\",\"unless\",\"d-button\",\"action\"]]",
  "moduleName": "discourse/templates/email-login.hbs",
  "isStrictMode": false
});